import React from 'react';
import { Link, useParams } from 'react-router-dom';
import HeaderSection from '../components/shared/HeaderSection';

const products = [
  {
    id: 'ecommerce-platform',
    title: 'E-commerce Platform',
    description: 'A robust platform to build and manage your online store.',
    image: '/images/products/ecommerce-platform.jpg',
  },
  {
    id: 'shopping-cart-system',
    title: 'Shopping Cart System',
    description: 'A seamless shopping cart experience for your customers.',
    image: '/images/products/shopping-cart-system.jpg',
  },
  {
    id: 'pos',
    title: 'Point of Sales (POS)',
    description: 'An efficient POS system for your retail business.',
    image: '/images/products/pos.png',
  },
  {
    id: 'stock-management',
    title: 'Stock Management System',
    description: 'Track and manage your inventory with ease.',
    image: '/images/products/stock-management.jpg',
  },
  {
    id: 'hr-management',
    title: 'HR Management System',
    description: 'Streamline your HR processes with our solutions.',
    image: '/images/products/hr-management.jpg',
  },
  {
    id: 'healthcare-management',
    title: 'Health Care Management System',
    description: 'Manage healthcare operations efficiently.',
    image: '/images/products/healthcare-management.jpg',
  },
  {
    id: 'warehouse-management',
    title: 'Warehouse Management System',
    description: 'Optimize your warehouse operations.',
    image: '/images/products/warehouse-management.jpg',
  },
  {
    id: 'library-management',
    title: 'Library Management System',
    description: 'Optimize your library operations.',
    image: '/images/products/library-management.jpg',
  }
];

const Products = () => {
  const { productId } = useParams<{ productId: string }>();
  const product = products.find((p) => p.id === productId);

  if (!product) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <h1 className="text-2xl font-bold text-gray-800">Product not found</h1>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-gray-100 text-gray-800">
        {/* Header Section */}
        <HeaderSection
            image="/images/bg-images/request-quote-bg.jpeg"
            header="Our Products"
            subHeader="Find the Right Product for You – Request a Quote Instantly!"
        />
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <img
            src={product.image}
            alt={product.title}
            className="w-full h-auto rounded-lg shadow-lg"
          />
          <div>
            <h1 className="text-2xl sm:text-4xl font-bold text-blue-600 mb-4">{product.title}</h1>
            <p className="text-lg text-gray-700 mb-6">{product.description}</p>
            <button className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-3 rounded-lg font-semibold hover:shadow-lg hover:scale-105 transition-all duration-300">
              {product.id === "ecommerce-platform" || product.id === "shopping-cart-system" ? (
                <Link to="/packages">
                  View Packages
                </Link>
              ) : (
                <Link to="/quote">
                  Request a Quote
                </Link>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;